import React, { useContext, useEffect, useState, useMemo } from 'react';
import { ShopContext } from '../context/shopcontext';
import ProductItem from '../components/ProductItem';
import Title from '../components/Title';
import Spinner from '../components/Spinner'; // ✅ Import spinner
import SearchBar from '../components/SearchBar'; // ✅ Import SearchBar (if reusable)

const Wishlist = () => {
  const { fetchWishlist, wishlist, token } = useContext(ShopContext);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const loadWishlist = async () => {
      setLoading(true);
      await fetchWishlist();
      setLoading(false);
    };
    if (token) loadWishlist();
  }, [token]);

  const uniqueWishlist = useMemo(
    () =>
      wishlist.filter((item, index, self) => index === self.findIndex((i) => i._id === item._id)),
    [wishlist]
  );

  // ✅ Filtered wishlist based on search term
  const filteredWishlist = useMemo(
    () =>
      uniqueWishlist.filter((product) =>
        product.name.toLowerCase().includes(searchTerm.toLowerCase())
      ),
    [uniqueWishlist, searchTerm]
  );

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen pt-20">
        <Spinner />
      </div>
    );
  }

  if (!uniqueWishlist || uniqueWishlist.length === 0) {
    return (
      <div className="flex justify-center items-center min-h-screen pt-20 text-gray-500">
        <p>Your wishlist is empty!</p>
      </div>
    );
  }

  return (
    <div className="p-4 pt-32">
      {/* Title */}
      <div className="text-xl mb-4 text-center">
        <Title text1="MY " text2="WISHLIST" />
      </div>

      {/* ✅ Search Bar */}
      <div className="mb-6 max-w-md mx-auto relative">
        <span className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg
            className="w-4 h-4 text-[#4c0f2e]"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"
            />
          </svg>
        </span>
        <input
          type="text"
          placeholder="Search your wishlist..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full border border-[#4c0f2e] rounded-md px-10 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#4c0f2e]/50 placeholder-gray-400"
        />
      </div>

      {/* Products */}
      {filteredWishlist.length === 0 ? (
        <p className="text-center text-gray-500">No matching products found.</p>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1 gap-y-2">
          {filteredWishlist.map((product) => (
            <ProductItem
              key={product._id}
              id={product._id}
              image={product.image}
              name={product.name}
              price={product.price}
              rating={product.averageRating || 0}
              totalReviews={product.totalReviews}
              bestseller={product.bestseller}
              category={product.category}
              subCategory={product.subCategory}
              inStock={product.inStock}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default Wishlist;
